export { default as Img200 } from './processed/200/Boardwalk-Empire-S1.jpg';
export { default as Img400 } from './processed/400/Boardwalk-Empire-S1.jpg';
export { default as Imgthumb } from './processed/thumb/Boardwalk-Empire-S1.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Boardwalk-Empire-S1.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Boardwalk-Empire-S1.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      188,
      140,
      76
    ],
    "_population": 1,
    "_hsl": [
      0.09523809523809525,
      0.45528455284552855,
      0.5176470588235295
    ]
  },
  "LightVibrant": {
    "_rgb": [
      240,
      210,
      170
    ],
    "_population": 205,
    "_hsl": [
      0.09523809523809523,
      0.7,
      0.803921568627451
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      73,
      32,
      19
    ],
    "_population": 43,
    "_hsl": [
      0.04012345679012346,
      0.5869565217391304,
      0.1803921568627451
    ]
  },
  "Muted": {
    "_rgb": [
      152,
      129,
      101
    ],
    "_population": 897,
    "_hsl": [
      0.0915032679738562,
      0.2015810276679842,
      0.49607843137254903
    ]
  },
  "LightMuted": {
    "_rgb": [
      200,
      189,
      168
    ],
    "_population": 279,
    "_hsl": [
      0.10937500000000006,
      0.2253521126760563,
      0.7215686274509804
    ]
  },
  "DarkMuted": {
    "_rgb": [
      80,
      64,
      41
    ],
    "_population": 260,
    "_hsl": [
      0.09829059829059829,
      0.32231404958677684,
      0.2372549019607843
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Boardwalk-Empire-S1.js